import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Back(props: IconProps) {
  return (
    <IconSvg {...props} viewBox="0 0 44 44">
      <path d="M44 21.988a1 1 0 01-1 1H3.414L15.707 35.28a1 1 0 11-1.414 1.414l-14-14a1 1 0 010-1.414l14-14a1 1 0 011.414 1.414L3.414 20.988H43a1 1 0 011 1z"></path>
    </IconSvg>
  );
}
